import moment from 'moment'
import { SESSION_INACTIVITY_MS } from '../config/sessionConfig'

export const LAST_ACTIVITY_KEY = 'lastActivityAt'

export const getLastActivityAt = () => {
  try {
    const raw = localStorage.getItem(LAST_ACTIVITY_KEY)
    const n = Number(raw)
    return Number.isFinite(n) && n > 0 ? n : null
  } catch {
    return null
  }
}

export const setLastActivityAt = (timestamp = moment().valueOf()) => {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(timestamp))
  } catch {
    // ignore quota / private mode
  }
}

export const clearLastActivityAt = () => {
  try {
    localStorage.removeItem(LAST_ACTIVITY_KEY)
  } catch {
    // ignore
  }
}

/**
 * True when the user has been idle longer than SESSION_INACTIVITY_MS
 * (survives browser close — based on persisted lastActivityAt).
 */
export const isSessionInactive = (timeoutMs = SESSION_INACTIVITY_MS) => {
  const timeout = Number(timeoutMs)
  if (!Number.isFinite(timeout) || timeout <= 0) return false

  const lastActivityAt = getLastActivityAt()
  if (!lastActivityAt) return false

  return moment().valueOf() - lastActivityAt >= timeout
}
